import type { LoginFormValues } from './login-form.schema';

export const loginFormMockValues: Record<'empty' | 'partial' | 'complete', LoginFormValues> = {
  empty: {
    email: '',
    password: '',
    remember: false,
  },
  partial: {
    email: 'maria@ejemplo.com',
    password: '',
    remember: true,
  },
  complete: {
    email: 'maria@ejemplo.com',
    password: 'adipa123',
    remember: true,
  },
};
